function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.666626,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#77A0C5",
    fillOpacity: 0.4,
    style: {
      fill: "#77A0C5",
      fill: "color(display-p3 0.4667 0.6275 0.7725)",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6165 14.0974C21.6741 14.1502 21.7317 14.2295 21.7317 14.3377C21.7317 14.446 21.7029 14.5252 21.6165 14.578C21.5301 14.6308 21.4725 14.6573 21.3832 14.6573C21.1787 14.6573 21.0059 14.4962 21.0059 14.3113C21.0059 14.2321 21.0347 14.1238 21.1211 14.071C21.1787 14.0182 21.2651 13.9654 21.3832 13.9654C21.5013 13.9654 21.5589 14.0182 21.6165 14.0974Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6165 15.0823C21.6741 15.1351 21.7317 15.2143 21.7317 15.3226C21.7317 15.4309 21.7029 15.5101 21.6165 15.5629C21.5301 15.6157 21.4725 15.6685 21.3544 15.6685C21.1499 15.6685 20.9771 15.5075 20.9771 15.3226C20.9771 15.2434 21.0059 15.1351 21.0923 15.0823C21.1499 15.0295 21.2363 14.9767 21.3544 14.9767C21.4725 14.9767 21.5589 15.0295 21.6165 15.0823Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6165 17.4247C21.6741 17.4775 21.7317 17.5567 21.7317 17.665C21.7317 17.7732 21.7029 17.8525 21.6165 17.9053C21.5301 17.9581 21.4725 18.0109 21.3544 18.0109C21.1499 18.0109 20.9771 17.8525 20.9771 17.665C20.9771 17.5857 21.0059 17.4775 21.0923 17.4247C21.1499 17.3719 21.2363 17.319 21.3544 17.319C21.4725 17.319 21.5589 17.3454 21.6165 17.4247Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6165 18.4096C21.6741 18.4624 21.7317 18.5417 21.7317 18.6499C21.7317 18.7582 21.7029 18.8374 21.6165 18.8902C21.5301 18.9431 21.4725 18.9959 21.3544 18.9959C21.1499 18.9959 20.9771 18.8374 20.9771 18.6499C20.9771 18.5707 21.0059 18.4624 21.0923 18.4096C21.1499 18.3568 21.2363 18.304 21.3544 18.304C21.4725 18.304 21.5589 18.3568 21.6165 18.4096Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6165 19.421C21.6741 19.4739 21.7317 19.5531 21.7317 19.6613C21.7317 19.7406 21.7029 19.8488 21.6165 19.9016C21.5301 19.9545 21.4725 19.9809 21.3832 19.9809C21.1787 19.9809 21.0059 19.8224 21.0059 19.6349C21.0059 19.5557 21.0347 19.4474 21.1211 19.3946C21.1787 19.3418 21.2651 19.289 21.3832 19.289C21.5013 19.289 21.5589 19.3418 21.6165 19.421Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6165 20.406C21.6741 20.4588 21.7317 20.5381 21.7317 20.6463C21.7317 20.7256 21.7029 20.8338 21.6165 20.8866C21.5301 20.9395 21.4725 20.9923 21.3544 20.9923C21.1499 20.9923 20.9771 20.8338 20.9771 20.6463C20.9771 20.5671 21.0059 20.4588 21.0923 20.406C21.1499 20.3532 21.2363 20.3004 21.3544 20.3004C21.4725 20.3004 21.5589 20.3532 21.6165 20.406Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6165 21.4174C21.6741 21.4702 21.7317 21.5494 21.7317 21.6577C21.7317 21.7369 21.7029 21.8452 21.6165 21.898C21.5301 21.9508 21.4725 22.0036 21.3544 22.0036C21.1499 22.0036 20.9771 21.8452 20.9771 21.6577C20.9771 21.5785 21.0059 21.4702 21.0923 21.4174C21.1499 21.3646 21.2363 21.3118 21.3544 21.3118C21.4725 21.3118 21.5589 21.3382 21.6165 21.4174Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6165 22.4024C21.6741 22.4552 21.7317 22.5345 21.7317 22.6427C21.7317 22.722 21.7029 22.8302 21.6165 22.883C21.5301 22.9359 21.4725 22.9887 21.3544 22.9887C21.1499 22.9887 20.9771 22.8302 20.9771 22.6427C20.9771 22.5635 21.0059 22.4552 21.0923 22.4024C21.1499 22.3496 21.2363 22.2968 21.3544 22.2968C21.4725 22.2968 21.5589 22.3496 21.6165 22.4024Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1778 14.0974C12.2354 14.1502 12.293 14.2295 12.293 14.3377C12.293 14.446 12.2642 14.5252 12.1778 14.578C12.0913 14.6308 12.0337 14.6573 11.9445 14.6573C11.74 14.6573 11.5671 14.4962 11.5671 14.3113C11.5671 14.2321 11.5959 14.1238 11.6824 14.071C11.74 14.0182 11.8264 13.9654 11.9445 13.9654C12.0625 13.9654 12.1173 14.0182 12.1778 14.0974Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1778 15.0823C12.2354 15.1351 12.293 15.2143 12.293 15.3226C12.293 15.4309 12.2642 15.5101 12.1778 15.5629C12.0913 15.6157 12.0337 15.6685 11.9156 15.6685C11.7111 15.6685 11.5383 15.5075 11.5383 15.3226C11.5383 15.2434 11.5671 15.1351 11.6535 15.0823C11.7111 15.0295 11.7976 14.9767 11.9156 14.9767C12.0337 14.9767 12.1201 15.0295 12.1778 15.0823Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1778 17.4247C12.2354 17.4775 12.293 17.5567 12.293 17.665C12.293 17.7732 12.2642 17.8525 12.1778 17.9053C12.0913 17.9581 12.0337 18.0109 11.9156 18.0109C11.7111 18.0109 11.5383 17.8525 11.5383 17.665C11.5383 17.5857 11.5671 17.4775 11.6535 17.4247C11.7399 17.3719 11.7976 17.319 11.9156 17.319C12.0337 17.319 12.1201 17.3454 12.1778 17.4247Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1778 18.4096C12.2354 18.4624 12.293 18.5417 12.293 18.6499C12.293 18.7582 12.2642 18.8374 12.1778 18.8902C12.0913 18.9431 12.0337 18.9959 11.9156 18.9959C11.7111 18.9959 11.5383 18.8374 11.5383 18.6499C11.5383 18.5707 11.5671 18.4624 11.6535 18.4096C11.7399 18.3568 11.7976 18.304 11.9156 18.304C12.0337 18.304 12.1201 18.3568 12.1778 18.4096Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1778 19.421C12.2354 19.4739 12.293 19.5531 12.293 19.6613C12.293 19.7406 12.2642 19.8488 12.1778 19.9016C12.0913 19.9545 12.0337 19.9809 11.9445 19.9809C11.74 19.9809 11.5671 19.8224 11.5671 19.6349C11.5671 19.5557 11.5959 19.4474 11.6824 19.3946C11.7688 19.3418 11.8264 19.289 11.9445 19.289C12.0625 19.289 12.1173 19.3418 12.1778 19.421Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1778 20.406C12.2354 20.4588 12.293 20.5381 12.293 20.6463C12.293 20.7256 12.2642 20.8338 12.1778 20.8866C12.0913 20.9395 12.0337 20.9923 11.9156 20.9923C11.7111 20.9923 11.5383 20.8338 11.5383 20.6463C11.5383 20.5671 11.5671 20.4588 11.6535 20.406C11.7399 20.3532 11.7976 20.3004 11.9156 20.3004C12.0337 20.3004 12.1201 20.3532 12.1778 20.406Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1778 21.4174C12.2354 21.4702 12.293 21.5494 12.293 21.6577C12.293 21.7369 12.2642 21.8452 12.1778 21.898C12.0913 21.9508 12.0337 22.0036 11.9156 22.0036C11.7111 22.0036 11.5383 21.8452 11.5383 21.6577C11.5383 21.5785 11.5671 21.4702 11.6535 21.4174C11.7399 21.3646 11.7976 21.3118 11.9156 21.3118C12.0337 21.3118 12.1201 21.3382 12.1778 21.4174Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1778 22.4024C12.2354 22.4552 12.293 22.5345 12.293 22.6427C12.293 22.722 12.2642 22.8302 12.1778 22.883C12.0913 22.9359 12.0337 22.9887 11.9156 22.9887C11.7111 22.9887 11.5383 22.8302 11.5383 22.6427C11.5383 22.5635 11.5671 22.4552 11.6535 22.4024C11.7399 22.3496 11.7976 22.2968 11.9156 22.2968C12.0337 22.2968 12.1201 22.3496 12.1778 22.4024Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8506 12.3387H12.6731C12.4686 12.3387 12.2958 12.1776 12.2958 11.9927C12.2958 11.8079 12.4715 11.6468 12.6731 11.6468H14.5021V8.66546H9.39246V11.6732H11.2214C11.4259 11.6732 11.5988 11.8317 11.5988 12.0192C11.5988 12.2066 11.4259 12.3651 11.2214 12.3651H9.04394C8.83944 12.3651 8.66663 12.204 8.66663 12.0192V8.34593C8.66663 8.15844 8.84232 8 9.04394 8H14.8506C15.0551 8 15.2279 8.16108 15.2279 8.34593V11.9927C15.1991 12.1802 15.0234 12.3387 14.8506 12.3387Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6731 13.6696C12.4686 13.6696 12.2958 13.5085 12.2958 13.3237V12.3123H11.5699V13.3237C11.5699 13.5112 11.3943 13.6696 11.1926 13.6696C10.991 13.6696 10.8441 13.5085 10.8441 13.3237V11.9928C10.8441 11.8053 11.0198 11.6469 11.2214 11.6469H12.6731C12.8776 11.6469 13.0504 11.8079 13.0504 11.9928V13.3237C13.0216 13.5112 12.8459 13.6696 12.6731 13.6696Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0216 13.6696H10.8441C10.6396 13.6696 10.4668 13.5085 10.4668 13.3237C10.4668 13.1388 10.6396 12.9777 10.8441 12.9777H13.0216C13.2261 12.9777 13.3989 13.1388 13.3989 13.3237C13.3989 13.5085 13.2261 13.6696 13.0216 13.6696Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3989 11.0078H10.4956C10.2911 11.0078 10.1183 10.8467 10.1183 10.6618C10.1183 10.477 10.2911 10.3159 10.4956 10.3159H13.3989C13.6034 10.3159 13.7763 10.477 13.7763 10.6618C13.7474 10.8493 13.5718 11.0078 13.3989 11.0078Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2893 12.3387H22.1118C21.9073 12.3387 21.7345 12.1776 21.7345 11.9927C21.7345 11.8079 21.9102 11.6468 22.1118 11.6468H23.912V8.66546H18.8312V11.6732H20.6602C20.8647 11.6732 21.0375 11.8317 21.0375 12.0192C21.0375 12.2066 20.8618 12.3651 20.6602 12.3651H18.4827C18.2782 12.3651 18.1053 12.204 18.1053 12.0192V8.34593C18.1053 8.15844 18.2782 8 18.4827 8H24.2893C24.4938 8 24.6666 8.16108 24.6666 8.34593V11.9927C24.6378 12.1802 24.4621 12.3387 24.2893 12.3387Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1118 13.6696C21.9073 13.6696 21.7345 13.5085 21.7345 13.3237V12.3123H21.0087V13.3237C21.0087 13.5112 20.833 13.6696 20.6313 13.6696C20.4297 13.6696 20.254 13.5085 20.254 13.3237V11.9928C20.254 11.8053 20.4268 11.6469 20.6313 11.6469H22.083C22.2875 11.6469 22.4603 11.8079 22.4603 11.9928V13.3237C22.4603 13.5112 22.2846 13.6696 22.1118 13.6696Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4603 13.6696H20.2828C20.0783 13.6696 19.9055 13.5085 19.9055 13.3237C19.9055 13.1388 20.0812 12.9777 20.2828 12.9777H22.4603C22.6648 12.9777 22.8377 13.1388 22.8377 13.3237C22.8377 13.5085 22.6648 13.6696 22.4603 13.6696Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8377 11.0078H19.9343C19.7298 11.0078 19.557 10.8467 19.557 10.6618C19.557 10.477 19.7298 10.3159 19.9343 10.3159H22.8377C23.0422 10.3159 23.215 10.477 23.215 10.6618C23.1862 10.8493 23.0105 11.0078 22.8377 11.0078Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5541 22.6427H17.3766C17.1721 22.6427 16.9993 22.4842 16.9993 22.2968C16.9993 22.1093 17.1721 21.9508 17.3766 21.9508H19.2056V18.9959H14.1248V22.0036H15.9537C16.1582 22.0036 16.3311 22.1647 16.3311 22.3496C16.3311 22.5344 16.1554 22.6955 15.9537 22.6955H13.7474C13.5429 22.6955 13.3701 22.5344 13.3701 22.3496V18.6499C13.3701 18.4625 13.5429 18.304 13.7474 18.304H19.5541C19.7586 18.304 19.9314 18.4625 19.9314 18.6499V22.3232C19.9314 22.4842 19.7586 22.6427 19.5541 22.6427Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3766 23.9736C17.1721 23.9736 16.9993 23.8152 16.9993 23.6277V22.6427H16.2734V23.6541C16.2734 23.8416 16.1006 24 15.8961 24C15.6916 24 15.5188 23.8416 15.5188 23.6541V22.3232C15.5188 22.1357 15.6916 21.9772 15.8961 21.9772H17.3478C17.5523 21.9772 17.7251 22.1383 17.7251 22.3232V23.6541C17.7539 23.8152 17.5811 23.9736 17.3766 23.9736Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7539 23.9737H15.5764C15.3719 23.9737 15.1991 23.8152 15.1991 23.6277C15.1991 23.4402 15.3719 23.2818 15.5764 23.2818H17.7539C17.9584 23.2818 18.1312 23.4402 18.1312 23.6277C18.1024 23.8152 17.9267 23.9737 17.7539 23.9737Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1024 21.3118H15.1991C14.9946 21.3118 14.8218 21.1534 14.8218 20.9659C14.8218 20.7784 14.9975 20.6199 15.1991 20.6199H18.1024C18.3069 20.6199 18.4797 20.7784 18.4797 20.9659C18.4797 21.1534 18.304 21.3118 18.1024 21.3118Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9203 17.3164C13.4278 17.3164 13.0188 16.9441 13.0188 16.4899C13.0188 16.0357 13.4249 15.666 13.9203 15.666C14.4157 15.666 14.8219 16.0383 14.8219 16.4899C14.8219 16.9414 14.4157 17.3164 13.9203 17.3164ZM13.9203 16.3314C13.8339 16.3314 13.7475 16.4106 13.7475 16.4899C13.7475 16.5691 13.8339 16.6509 13.9203 16.6509C14.0067 16.6509 14.096 16.5717 14.096 16.4899C14.096 16.408 14.0384 16.3314 13.9203 16.3314Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1006 17.3164C15.608 17.3164 15.2019 16.9441 15.2019 16.4899C15.2019 16.0357 15.608 15.666 16.1006 15.666C16.5931 15.666 17.0021 16.0383 17.0021 16.4899C17.0021 16.9414 16.596 17.3164 16.1006 17.3164ZM16.1006 16.3314C16.0141 16.3314 15.9277 16.4106 15.9277 16.4899C15.9277 16.5691 16.0141 16.6509 16.1006 16.6509C16.187 16.6509 16.2734 16.5717 16.2734 16.4899C16.2734 16.408 16.2158 16.3314 16.1006 16.3314Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2781 17.3164C17.7856 17.3164 17.3766 16.9441 17.3766 16.4899C17.3766 16.0357 17.7827 15.666 18.2781 15.666C18.7735 15.666 19.1796 16.0383 19.1796 16.4899C19.1796 16.9414 18.7735 17.3164 18.2781 17.3164ZM18.2781 16.3314C18.1917 16.3314 18.1053 16.4106 18.1053 16.4899C18.1053 16.5691 18.1917 16.6509 18.2781 16.6509C18.3645 16.6509 18.4509 16.5717 18.4509 16.4899C18.4509 16.408 18.3933 16.3314 18.2781 16.3314Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.912 16.812H18.8312C18.6267 16.812 18.4539 16.6536 18.4539 16.4661C18.4539 16.2786 18.6267 16.1202 18.8312 16.1202H23.912C24.1165 16.1202 24.2893 16.2786 24.2893 16.4661C24.2893 16.6536 24.1136 16.812 23.912 16.812Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3989 16.812H9.04394C8.83944 16.812 8.66663 16.6536 8.66663 16.4661C8.66663 16.2786 8.84232 16.1202 9.04394 16.1202H13.3989C13.6034 16.1202 13.7763 16.2786 13.7763 16.4661C13.7763 16.6536 13.5718 16.812 13.3989 16.812Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5764 16.812H14.4733C14.2688 16.812 14.0959 16.6536 14.0959 16.4661C14.0959 16.2786 14.2688 16.1202 14.4733 16.1202H15.5764C15.7809 16.1202 15.9537 16.2786 15.9537 16.4661C15.9537 16.6536 15.7492 16.812 15.5764 16.812Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7539 16.812H16.6508C16.4463 16.812 16.2734 16.6536 16.2734 16.4661C16.2734 16.2786 16.4491 16.1202 16.6508 16.1202H17.7539C17.9584 16.1202 18.1312 16.2786 18.1312 16.4661C18.1312 16.6536 17.9267 16.812 17.7539 16.812Z",
    fill: "#4170A0",
    style: {
      fill: "#4170A0",
      fill: "color(display-p3 0.2549 0.4392 0.6275)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.8096fba545b52dad4c5ae208ffeee372.svg";
export { ForwardRef as ReactComponent };